import classnames from 'classnames';
import React from 'react';

import * as styles from './table.module.scss';

interface TableProps {
  isFirstColumnSticky?: boolean;
  isHighlighted?: boolean;
  children?: React.ReactNode;
}

const TableRow: React.FC<TableProps> = (props) => {
  const { isFirstColumnSticky, children, isHighlighted } = props;

  return (
    <tr
      className={classnames(
        { [styles.Table__HeaderRow__stickyFirstColumn]: isFirstColumnSticky },
        { [styles['Table__Row--highlighted']]: isHighlighted },
      )}
      data-test-id={isHighlighted && 'highlighted-row'}
    >
      {children}
    </tr>
  );
};

export default TableRow;
